import { Component, Input, OnInit } from '@angular/core'
import { Booking } from '@app/domain/Booking'
import { Venue } from '@app/domain/Venue'
import { DateTime } from 'luxon'
import { ProductLibrary } from '@app/domain/ProductLibrary'
import { Menu } from '@app/domain/Consumable'
import { LineItemModifier } from '@app/domain/LineItem'
import {
    OrderDetailsData,
    PerCoverRow,
} from '@app/domain/BookingDocket'

@Component({
    selector: 'app-print-single-booking-order',
    templateUrl: './print-single-booking-order.component.html',
})
export class PrintSingleBookingOrderComponent implements OnInit {

    @Input() booking!: Booking
    @Input() venue!: Venue
    @Input() productLibrary: ProductLibrary | null = null

    menu: Menu | null = null
    orderData: OrderDetailsData | null = null

    constructor() {}

    ngOnInit() {
        this.injectStylesToIframe()
        this.resolveMenu()
        const docket = this.booking.docket
        if (docket && this.menu && this.productLibrary) {
            this.orderData = docket.buildOrderDetails(this.menu, this.productLibrary)
        }
    }

    private resolveMenu() {
        if (!this.productLibrary || !this.booking.docket) {
            this.menu = null
            return
        }
        this.menu = this.productLibrary.getMenu(this.booking.docket.menuId)
    }

    private injectStylesToIframe() {
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = 'styles.css'
        document.head.appendChild(link)
    }

    getSelectionsForCourse(row: PerCoverRow, courseName: string): string[] {
        return row.selectionsByCourse.get(courseName) || []
    }

    getModifierNames(modifiers: LineItemModifier[]): string {
        return modifiers.map(m => m.name).join(', ')
    }

    protected readonly DateTime = DateTime
}
